import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React, { useCallback, useState } from 'react'
import { actualizarPerfil } from '../../../../pages/Contracts/Vencimientos/contracts.services'
import SnackBarUtils from '../../../../utils/SnackBarUtils'
import { IPadron } from '../../../../dto/ContractDTO'

interface PropsDialog {
  open: boolean
  codLocal: string
  dataPadron: IPadron
  isMobile: boolean
  setOpen: (op: boolean) => void
  updateData: () => Promise<void>
}

const DialogPadron: React.FC<PropsDialog> = ({
  open,
  setOpen,
  codLocal,
  dataPadron,
  isMobile,
  updateData
}: PropsDialog) => {
  const [loading, setLoading] = useState<boolean>(false)

  const updateCuit = useCallback(async () => {
    try {
      setLoading(true)
      await actualizarPerfil(codLocal, {
        tipoIdentificacionFiscal: 'CUIT',
        numeroIdentificacionFiscal: dataPadron.cuit,
        nombreFiscal: `${dataPadron.nombre}, ${dataPadron.apellido}`,
        noFacturarASuNombre: false
      })
      SnackBarUtils.success('CUIT actualizado')
      updateData()
    } catch (e) {
      console.log(e)
      SnackBarUtils.error(
        e.message === 'Network Error' || !e.message ? 'Error al actualizar CUIT y consumidor final' : e.message
      )
    } finally {
      handleClose()
    }
  }, [codLocal, dataPadron])

  const handleClose = () => {
    setLoading(false)
    setOpen(false)
  }

  if (!dataPadron) return

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          overflowY: 'visible',
          overflowX: 'hidden',
          ...(isMobile && { ml: -30 })
        },
        '& .MuiDialogContent-root': {
          overflowY: 'visible'
        }
      }}
    >
      <DialogTitle fontWeight={'bold'}>Padrón AFIP</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <Typography fontWeight={'bold'}>{`${dataPadron.nombre} ${dataPadron.apellido}`}</Typography>
        {dataPadron.razonSocial && (
          <Typography>
            <strong>Razón Social: </strong>
            {dataPadron.razonSocial}
          </Typography>
        )}
        <Typography>
          <strong>CUIT: </strong>
          {dataPadron.cuit}
        </Typography>
        <Typography>
          <strong>Dirección: </strong>
          {`${dataPadron.direccion}, ${dataPadron.ciudad}, ${dataPadron.provincia}`}
        </Typography>
        {dataPadron.condicionFiscal && (
          <Typography>
            <strong>Condición Fiscal: </strong>
            {dataPadron.condicionFiscal}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <IconButton
          disabled={loading}
          edge="end"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '14px'
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', width: '100%', gap: '0.5rem' }}>
          <Button
            disabled={loading}
            sx={{ width: '100%' }}
            variant="contained"
            onClick={handleClose}
            size={isMobile ? 'small' : 'medium'}
            color="error"
          >
            Cancelar
          </Button>
          <Button
            disabled={loading}
            sx={{ width: '100%' }}
            variant="contained"
            onClick={updateCuit}
            size={isMobile ? 'small' : 'medium'}
            color="success"
          >
            Confirmar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default DialogPadron
